import { useState } from 'react';

const EditLecturerModal = ({ lecturer, onClose, onSave }) => {
    const [firstName, setFirstName] = useState(lecturer.first_name);
    const [lastName, setLastName] = useState(lecturer.last_name);
    const [email, setEmail] = useState(lecturer.email);
    const [academicPosition, setAcademicPosition] = useState(lecturer.academic_position || '');

    const handleSubmit = () => {
        const updatedLecturer = {
            ...lecturer,
            first_name: firstName,
            last_name: lastName,
            email,
            academic_position: academicPosition,
        };
        onSave(updatedLecturer);
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Edytuj wykładowcę</h3>
                <label>
                    Imię:
                    <input className='form-input' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </label>
                <label>
                    Nazwisko:
                    <input className='form-input' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </label>
                <label>
                    E-mail:
                    <input className='form-input' value={email} onChange={(e) => setEmail(e.target.value)} />
                </label>
                <label>
                    Tytuł naukowy:
                    <select
                            name='academic_position'
                            className='form-input'
                            value={academicPosition}
                            onChange={(e) => setAcademicPosition(e.target.value)}
                        >
                            <option value="">-- Wybierz --</option>
                            <option value='lic'>Licencjat</option>
                            <option value="Inż">Inżynier</option>
                            <option value="Mgr">Magister</option>
                            <option value="Mgr inż">Magister inżynier</option>
                            <option value="Dr">Doktor</option>
                            <option value="Dr hab">Doktor habilitowany</option>
                            <option value="Prof">Profesor</option>
                        </select>
                </label>
                <div className="modal-actions">
                    <button onClick={handleSubmit} className="button button-primary">Zapisz</button>
                    <button onClick={onClose} className="button button-secondary">Anuluj</button>
                </div>
            </div>
        </div>
    );
};
export default EditLecturerModal;